import * as React from 'react';
import { ApplicationContext } from '../components/ApplicationContext';
import { IAdaptiveSettings } from '../types/adaptiveSettings';

export function useIsMobileDevice(): boolean {
  const { config } = React.useContext(ApplicationContext);
  const adaptiveSettings = config.get<IAdaptiveSettings>('adaptiveSettings');
  const isMobile = Boolean(adaptiveSettings?.isMobile);

  return isMobile;
}
